import styles from '../centralAntrag.module.css';
// import stylesFlex from './flexkarteBestellen.module.css';
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { geschlecht, sportangebote, month, foerdervereinBeitrag, beitrag, addBeitrag, beteiligung, evaluation, accept } from '../../../../../config/meta-informationen';
import { showErrorToast } from '../../../../../code/ToastHelper';
import { Icons } from '../../../../../code/IconHandler';
import { isValidIban, createYears } from '../code';
function MitgliedschaftantragJugendfoerderer() {
    const navigate = useNavigate();
    const [submitted, setSubmitted] = useState(false);
    const [loading, setLoading] = useState(false);
    const today = new Date();
    const formattedDate = `${String(today.getDate()).padStart(2, '0')}.${String(today.getMonth() + 1).padStart(2, '0')}.${today.getFullYear()}`;
    const [formData, setFormData] = useState({
        formType: "orderFoerdervereinMitgliedschaft",
        dateToday: formattedDate,
        firstName: "",
        familyName: "",
        birthdate: "",
        telefon: "",
        email: "",
        street: "",
        zusatz: "",
        plz: "",
        area: "",
        beitrag: "",
        numberBeitrag: "",
        familyMembers: [],
        accountholder: "",
        bank: "",
        iban: "",
        bic: "",
        noticedSEPA: "",
        noticedHinweise: "",
        dataSecurity: "",

    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };
    const handleBeitragChange = (e) => {
        const value = e.target.value;
        setFormData(prev => ({
            ...prev,
            beitrag: value,
            addBeitrag: value === "once-yearly" ? prev.numberBeitrag : "",
            familyMembers: value === "family" ? (prev.familyMembers.length ? prev.familyMembers : []) : []
        }));
    };
    const addFamilyMember = () => {
        setFormData(prev => ({
            ...prev,
            familyMembers: [
                ...prev.familyMembers,
                { vorname: "", nachname: "", geburtsdatum: "", email: "" }
            ]
        }));
    };
    const updateFamilyMember = (index, field, value) => {
        setFormData(prev => {
            const list = [...prev.familyMembers];
            list[index] = { ...list[index], [field]: value };
            return { ...prev, familyMembers: list };
        });
    };
    const deleteFamilyMember = (index) => {
        const confirmDelete = window.confirm("Bist du sicher, dass du dieses Familienmitglied entfernen möchtest?");
        if (!confirmDelete) return;

        setFormData(prev => {
            const list = [...prev.familyMembers];
            list.splice(index, 1); // actually remove the item
            return { ...prev, familyMembers: list };
        });
    };


    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!/^\d{5}$/.test(formData['plz'])) {
            const plzInput = document.querySelector('input[name="plz"]');
            if (plzInput) {
                plzInput.focus();
                plzInput.classList.add('error');
            }
            return;
        }
        if (!isValidIban(formData['iban'])) {
            const ibanInput = document.querySelector('input[name="iban"]');
            if (ibanInput) {
                ibanInput.focus();
                ibanInput.classList.add('error');
            }
            return;
        }

        setLoading(true);
        console.log(JSON.stringify(formData));
        const dataToSend = {
            ...formData,
            beitrag: foerdervereinBeitrag[formData.beitrag] || formData.beitrag, // convert key to label
        };
        try {
            const response = await fetch("/api/email/send-emails", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(dataToSend),
            });

            const result = await response.json();

            if (response.ok) {
                setSubmitted(true);
            } else {
                showErrorToast("Fehler beim Senden: " + result.message);
            }
        } catch (error) {
            console.error("Ein Fehler ist aufgetreten:", error);
            showErrorToast("Beim Senden der Anfrage ist ein Fehler aufgetreten.");
        }
        setLoading(false)
    };

    const years = createYears();
    return (
        <section className={styles.container}>
            <h1>Antrag auf Mitgliedschaft beim Jugendförderverein</h1>

            {!submitted ? (
                <form className={styles.formular} onSubmit={handleSubmit}>
                    {/* Allgemeine Informationen */}
                    <div className={styles.section}>
                        <p className={styles.sectionTitle}>Allgemeine Informationen</p>
                        <div className={styles.area}>
                            <label>
                                <div>Vorname<span className={styles.required}>*</span></div>
                                <input type="text" name="firstName" placeholder='Max' required onChange={handleChange} />
                            </label>
                            <label>
                                <div>Nachname<span className={styles.required}>*</span></div>
                                <input type="text" name="familyName" placeholder='Mustermann' required onChange={handleChange} />
                            </label>
                        </div>
                        <div className={styles.area}>
                            <label>
                                <div>Geburtsdatum<span className={styles.required}>*</span></div>
                                <input type="date" name="birthdate" required onChange={handleChange} />
                            </label>
                            <label>
                                <div>Telefonnummer<span className={styles.required}>*</span></div>
                                <input type="tel" name="telefon" placeholder='0177123456789' required onChange={handleChange} />
                            </label>
                        </div>
                        <div className={styles.area}>
                            <label>
                                <div>E-Mail<span className={styles.required}>*</span></div>
                                <input type="email" name="email" placeholder='max.mustermann@muster-adresse.de' required onChange={handleChange} />
                            </label>
                        </div>
                    </div>
                    {/* Adresse */}
                    <div className={styles.section}>
                        <p className={styles.sectionTitle}>Adresse</p>
                        <div className={styles.area}>
                            <label className={styles.big}>
                                <div>Straße + Hausnummer<span className={styles.required}>*</span></div>
                                <input type="text" name="street" placeholder='Musterstraße 1a' required onChange={handleChange} />
                            </label>
                        </div>
                        <div className={styles.area}>
                            <label>
                                <div>Zusatz</div>
                                <input type="text" name="zusatz" placeholder='Hinterhof' onChange={handleChange} />
                            </label>
                        </div>
                        <div className={styles.area}>
                            <label className={styles.small}>
                                <div>PLZ<span className={styles.required}>*</span></div>
                                <input type="text" name="plz" placeholder='53639' pattern="\d{5}" required onChange={handleChange}
                                    maxLength={5}
                                    inputMode="numeric"
                                    title="Bitte eine fünfstellige Postleitzahl eingeben"
                                />
                            </label>
                            <label className={styles.big}>
                                <div>Ort<span className={styles.required}>*</span></div>
                                <input type="text" name="area" placeholder='Königswinter' required onChange={handleChange} />
                            </label>

                        </div>
                    </div>
                    {/* Auswahl Mitgliedschaft */}
                    <div className={styles.section}>
                        <div>
                            <p className={styles.sectionTitle}>Auswahl Mitgliedschaft / Beitragsart</p>
                        </div>
                        <div className={styles.beitrag}>
                            <label className={styles.beitragLabelRow}>

                                <div className={styles.beitragInputs}>
                                    <select
                                        name="beitrag"
                                        value={formData.beitrag}
                                        onChange={handleBeitragChange}
                                        required
                                    >
                                        <option value="" disabled>Wähle eine Beitragsart...</option>
                                        {Object.keys(foerdervereinBeitrag).map((key) => (
                                            <option key={key} value={key}>
                                                {foerdervereinBeitrag[key]}
                                            </option>
                                        ))}
                                    </select>

                                    {formData.beitrag === "once-yearly" && (
                                        <>
                                            <input
                                                type="number"
                                                name="numberBeitrag"
                                                min="1"
                                                step="1"
                                                placeholder=""
                                                value={formData.numberBeitrag}
                                                onChange={handleChange}
                                                className={styles.amountInput}
                                                aria-label="Jährlicher Spendenbetrag"
                                                required
                                            />
                                            <span>€ / Jahr</span>
                                        </>
                                    )}
                                </div>
                                {formData.beitrag === "family" && (
                                    <div className={styles.familyArea}>
                                        <h5>Weitere Familienmitglieder bennen</h5>

                                        {formData.familyMembers.map((m, idx) => (
                                            <div key={idx} className={styles.inline}>
                                                <div className={styles.familyMemberRow}>
                                                    <input
                                                        type="text"
                                                        placeholder="Vorname"
                                                        value={m.vorname}
                                                        onChange={(e) => updateFamilyMember(idx, "vorname", e.target.value)}
                                                        required
                                                    />
                                                    <input
                                                        type="text"
                                                        placeholder="Nachname"
                                                        value={m.nachname}
                                                        onChange={(e) => updateFamilyMember(idx, "nachname", e.target.value)}
                                                        required
                                                    />
                                                    <input
                                                        type="date"
                                                        placeholder="Geburtsdatum"
                                                        value={m.geburtsdatum}
                                                        onChange={(e) => updateFamilyMember(idx, "geburtsdatum", e.target.value)}
                                                        required
                                                    />
                                                    <input
                                                        type="email"
                                                        placeholder="E-Mail"
                                                        value={m.email}
                                                        onChange={(e) => updateFamilyMember(idx, "email", e.target.value)}
                                                    />
                                                </div>
                                                <button className={styles.deleteMemberButton} onClick={(e) => deleteFamilyMember(idx)}>
                                                    <Icons.X></Icons.X>
                                                </button>
                                            </div>
                                        ))}

                                        <button type="button" className={styles.addMemberBtn} onClick={addFamilyMember}>
                                            + weiteres Familienmitglied hinzufügen
                                        </button>
                                    </div>
                                )}
                            </label>
                        </div>
                    </div>
                    {/*Hinweis zur Beitragszahlung*/}
                    <div className={styles.section}>
                        <div>
                            <p className={styles.sectionTitle}>Hinweis zur Beitragszahlung</p>
                        </div>
                        <div className={styles.area}>
                            <div className={styles.areaSpecial}>
                                <ul>
                                    <li>Der Jahresbeitrag wird im Februar jeden Jahres per SEPA-Lastschriftmandat eingezogen. Anfallende Gebühren bei Nichteinlösung des SEPA-Lastschriftmandats gehen in vollem Umfang zu Lasten des Mitgliedes.</li>
                                    <li>Bei Eintritt der Mitgliedschaft innerhalb eines laufenden Jahres wird der Beitrag anteilig auf die verbleibenden vollen Monat bis Jahresende berechnet und per Lastschrift eingezogen.</li>
                                    <li>Die Mitgliedschaft kann unter Einhaltung einer dreimonatigen Kündigungsfrist zu den Stichtagen 30.06. und 31.12. eines Jahres beendet werden. Auf eine anteilige Rückerstattung des Mitgliedbeitrags verzichte ich.</li>
                                    <li>Die Mitglieder sind verpflichtet, dem Verein Förderer des Jugendfußballs im TuS 1905 Oberpleis e.V. Änderungen des Namens, der Kontoverbindung und der Wohnanschrift unverzüglich und schriftlich oder per eMail mitzuteilen.</li>
                                </ul>
                                <label>
                                    <div>Kenntnisnahme:</div>
                                    <div><input type="checkbox" name="noticedHinweise" required onChange={handleChange} /><span className={styles.required}>*</span></div>

                                </label>
                            </div>
                        </div>
                    </div>
                    {/* SEPA-Lastschriftmandat */}
                    <div className={styles.section}>
                        <div>
                            <p className={styles.sectionTitle}>SEPA-Lastschriftmandat</p>
                        </div>
                        <div className={styles.area}>
                            <label>
                                <div>Kontoinhaber<span className={styles.required}>*</span></div>
                                <input type="text" name="accountholder" placeholder='Max Mustermann' required onChange={handleChange} />
                            </label>
                            <label>
                                <div>Name der Bank<span className={styles.required}>*</span></div>
                                <input type="text" name="bank" required onChange={handleChange}
                                    inputMode="text"
                                    placeholder='z.B. PSD Bank, Kreissparkasse Köln,...'
                                />
                            </label>
                        </div>
                        <div className={styles.area}>
                            <label>
                                <div>IBAN<span className={styles.required}>*</span></div>
                                <input type="text" name="iban" placeholder='DE01 2345 6789 0123 4567 89' required onChange={handleChange}
                                    inputMode="text"
                                    title="Bitte eine gültige IBAN eingeben (z.B. DE01 2345 6789 0123 4567 89)"
                                />
                            </label>
                            <label>
                                <div>BIC<span className={styles.required}>*</span></div>
                                <input type="text" name="bic" placeholder='GENODEF1P01' required onChange={handleChange}
                                    inputMode="text"
                                    title="Bitte eine gültige BIC eingeben (z.B. GENODEF1P01)"
                                />
                            </label>
                        </div>
                        <div className={styles.area}>
                            <div className={styles.areaSpecial}>
                                <p>(Gläubiger-ID: DE 64ZZZ00001092589)<br />
                                    Ich ermächtige den Verein Förderer des Jugendfußballs im TuS 1905 Oberpleis e.V. Zahlungen von meinem Konto mittels Lastschrift einzuziehen. Zugleich weise ich mein Kreditinstitut an, die vom Verein Förderer des Jugendfußballs im TuS 1905 Oberpleis e.V. auf mein Konto gezogenen Lastschriften einzulösen.</p>
                                <label>
                                    <div>Kenntnisnahme:</div>
                                    <div><input type="checkbox" name="noticedSEPA" required onChange={handleChange} /><span className={styles.required}>*</span></div>

                                </label>
                            </div>
                        </div>
                    </div>


                    {/* Datenschutzhinweis */}
                    <div className={styles.section}>
                        <div>
                            <p className={styles.sectionTitle}>Datenschutzhinweis</p>
                        </div>
                        <div className={styles.area}>
                            <div className={styles.areaSpecial}>
                                <p>Ich habe die sich auf der Homepage des Vereins (tus05-oberpleis.de) befindlichen Datenschutzhinweis gelesen und erkläre mich hiermit einverstanden. Sie können Ihre erteilte Einwilligung jederzeit mit Wirkung für die Zukunft gem. Art. 7 Abs. 3 DSGVO widerrufen. Ebenso können Sie der künftigen Verarbeitung der Sie betreffenden Daten nach Maßgabe des Art. 21 DSGVO jederzeit widersprechen: <span tabIndex={0} onClick={() => { navigate("/datenschutz") }}
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter" || e.key === " ") {

                                            e.preventDefault(); // Prevent space from scrolling
                                            navigate("/datenschutz")
                                        }
                                    }}>Datenschutzerklärung</span></p>
                                <label>
                                    <div>Ich stimme der Datenschutzerklärung zu:</div>
                                    <div><input type="checkbox" name="dataSecurity" required onChange={handleChange} /><span className={styles.required}>*</span></div>

                                </label>
                            </div>
                        </div>
                    </div>
                    <button type="submit">
                        {loading ? (
                            <>
                                <span className={styles.spinner} /> Wird gesendet...
                            </>
                        ) : (
                            "Absenden"
                        )}
                    </button>
                </form>
            ) : (
                <div className={styles.bestaetigung}>
                    <img src='/images/logo.png' alt='Logo: TuS-05-Oberpleis'></img>
                    <div className={styles.text}>
                        <p>Der Antrag zur Mitgliedschaft wurde erfolgreich übermittelt!</p>
                        <p>Sie erhalten zusätzlich eine Bestätigung per E-Mail.</p>
                    </div>
                    <img className={styles.secondImg} src='/images/logo.png' alt='Logo: TuS-05-Oberpleis'></img>
                </div>
            )}
        </section >
    )
}

export default MitgliedschaftantragJugendfoerderer;